import { createFileRoute } from "@tanstack/react-router";
import { AdminSettingsPage } from "@/features/admin/settings";

export const Route = createFileRoute("/admin/settings")({
  head: () => ({ meta: [{ title: "Settings · Admin · Malfak" }] }),
  component: AdminSettingsPage,
});
